import { apiService } from './api.service';
import { logger } from '@/utils/logger';
import type { AxiosResponse } from 'axios';

export class TournamentFileService {
  static async download(fileId: number, fileName: string) {
    try {
      const response: AxiosResponse<Blob> = await apiService.get(`/tournament-files/${fileId}/download`, {
        responseType: 'blob'
      });
      
      // Явно указываем, что response.data это Blob
      const blob = new Blob([response.data], { 
        type: response.headers['content-type'] 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      logger.error('Error downloading file:', error);
      throw error;
    }
  }

  static async delete(fileId: number) {
    try {
      await apiService.delete(`/tournament-files/${fileId}`);
    } catch (error) {
      logger.error('Error deleting file:', error);
      throw error;
    }
  }
}